"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StepsSourceProvider = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _state = require("../state");
class StepsSourceProvider {
  constructor() {
    (0, _defineProperty2.default)(this, "name", "steps");
  }
  getValue(provider, source) {
    let dumbapp = provider.dumbapp;
    return {
      value() {
        if (dumbapp) {
          let stepNumber = source.step - 1;
          let step = dumbapp.steps[stepNumber];
          if (!step) {
            // It's possible to temporarily have the wrong dumbapp context when
            // switching dumbapps
            return null;
          }
          switch (source.name) {
            case "network":
              return (0, _state.resolveStringSourcable)(provider, [step.network], step);
            case "value":
              return (0, _state.resolveBigNumberishSourcable)(provider, [step.value], step);
            case "address":
              return (0, _state.resolveStringSourcable)(provider, [step.address], step);
          }
        }
      }
    };
  }
}
exports.StepsSourceProvider = StepsSourceProvider;
//# sourceMappingURL=StepsSourceProvider.js.map